module.exports = __webpack_public_path__ + "img/chevron.1738520a.svg";